// Self-contained data for the CPA Tax & Bookkeeping Firm Co. concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/10_CPA_Tax_and_Bookkeeping_Firm_Co
// (research snapshot 2026-08-21). Owner / named CPA could not be reliably identified — do not
// invent one. Source promotional graphics show two different unit numbers and phone numbers
// across different years; the dossier's synthesized current details (below) are used as the
// safest supported values.
export const BIZ = {
  name: "CPA Tax & Bookkeeping Firm Co.",
  tagline: "Accounting & Tax Support for Mandaluyong Businesses Since 2007",
  address: "Unit 2F, Unique Plaza Building, 56 Sierra Madre St., Mandaluyong City 1154",
  phone: "+639151760833",
  phoneDisplay: "+63 915 176 0833",
  email: "cpa_boa_168@yahoo.com",
  hours: "Mon–Fri 8:00 AM–5:00 PM, Sat–Sun 9:00 AM–5:00 PM",
  mapEmbed: "https://www.google.com/maps?q=Unique+Plaza+Building+56+Sierra+Madre+St+Mandaluyong+City&output=embed",
};

export const SERVICES = [
  { title: "Accounting", text: "General CPA and accounting services." },
  { title: "Bookkeeping", text: "Ongoing bookkeeping support." },
  { title: "Tax Compliance", text: "Tax preparation and income-tax assistance." },
  { title: "Business Support", text: "General tax-related professional services." },
];

export const WHY_CLIENTS = "Operating since August 2007, we've spent nearly two decades helping Mandaluyong-area businesses handle their accounting and tax work.";

export const HOW_ENGAGEMENT_WORKS = [
  { n: "1", title: "Reach Out", text: "Call or message us during business hours to describe your general accounting or tax need." },
  { n: "2", title: "Discuss Scope", text: "Talk through what ongoing support would look like for your business." },
  { n: "3", title: "Begin Engagement", text: "Start regular bookkeeping, tax and compliance support." },
];
